import { Box, Typography } from "@mui/material";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import styles from "../../../assets/styles/componentStyles/billingStyles/planSubscribedPopup.module.scss";

import GlobalPopUp from "../../utility/globalPopUp";
import GlobalButton from "../../utility/globalButton/button";
import useGenericHook from "../../../hooks/useGenericHook";

interface PlanSubscribedPopupProps {
    open: boolean;
    planName?: string;
    onClose: () => void;
    onContinue?: () => void;
}

const PlanSubscribedPopup = ({ open, planName, onClose, onContinue }: PlanSubscribedPopupProps) => {
    
    const { isScreenBelow600 } = useGenericHook();

    const handleContinue = () => {
        onContinue?.();
        onClose();
    };

    const activePlanLabel = planName ? `${planName} plan` : "plan";

    return (
        <GlobalPopUp
            open={open}
            onClose={onClose}
            handleClose={onClose}
            flagShowCloseIcon
            flagBackdrop
            titlePadding="5px"
            borderRadius="16px"
            paperMinWidth={isScreenBelow600 ? "300px" : "400px"}
            paperMaxwidth={isScreenBelow600 ? "350px" : "450px"}
        >
            <Box className={styles.content}>
                <Box className={styles.iconWrap}>
                    <CheckCircleOutlinedIcon className={styles.icon} />
                </Box>

                <Typography className={styles.title}>
                    Thank you for your purchase!
                </Typography>

                <Typography className={styles.description}>
                    Your payment was successful for the {activePlanLabel}.
                </Typography>

                <GlobalButton
                    buttonText="Continue"
                    className="primaryButtonStyle"
                    onClick={handleContinue}
                    sx={{ margin: "8px 0 0 0", minWidth: "100px" }}
                />
            </Box>
        </GlobalPopUp>
    );
};

export default PlanSubscribedPopup;